import { getVacancyNotationStatus } from '@/app/dashboard/vacancy-contracts/apartment/utils';
import industrialPremisesVacancyContractFilter from '@/app/dashboard/vacancy-contracts/industrial-premises/filters';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/cn';
import { toReadableDate } from '@/lib/dates';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  IndustrialPremisesVacancyNotationConfig,
  type IndustrialPremisesVacancyNotation,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const IndustrialPremisesVacancyItem: RelationFieldProps<IndustrialPremisesVacancyNotation> =
  {
    nested: getRelationFieldNames(IndustrialPremisesVacancyNotationConfig),
    filters: industrialPremisesVacancyContractFilter,
    renderItem: (item, isRelationField) => ({
      title: item?.space?.popularName ?? item.space?.customId ?? 'Saknar ID',
      badge: (() => {
        const { label, variant } = getVacancyNotationStatus(item);
        return <Badge variant={variant}>{label}</Badge>;
      })(),
      descriptionItems: (
        <div
          className={cn(
            isRelationField ? 'grid w-full' : 'flex flex-wrap items-center'
          )}
        >
          <span>Startdatum {toReadableDate(item.startDate)}</span>
          {item.endDate && (
            <span>Slutdatum {toReadableDate(item.endDate)}</span>
          )}
        </div>
      ),
    }),
  };
